import LocalizedStrings from "react-localization";

export const BisListingNotMappedFiltersStrings = new LocalizedStrings({
  en: {
    inputs: {
      bis: {
        id: "BIS ID",
        label: "BIS Label",
      },
    },
  },
  fr: {
    inputs: {
      bis: {
        id: "ID BIS",
        label: "Libellé BIS",
      },
    },
  },
});
